var _path, _path2, _path3, _ellipse, _path4, _ellipse2, _path5, _ellipse3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWriteForUsBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1240,
    height: 215,
    viewBox: "0 0 1240 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1005.33 123.598C980.237 120.973 966.295 149.805 966.295 163.805V187.43H1088.29C1084.1 186.773 1089.68 181.13 1075.74 163.805C1061.8 146.48 1048.09 156.586 1042.97 163.805C1038.33 151.992 1030.43 126.223 1005.33 123.598Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M909.366 147.535C884.05 145.894 869.986 163.914 869.986 172.664V187.43H993.047C988.828 187.02 994.454 183.492 980.389 172.664C966.325 161.836 952.496 168.152 947.339 172.664C942.651 165.281 934.681 149.175 909.366 147.535Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 185.136L1240 185.136",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 386.884,
    cy: 88.1895,
    rx: 46.8272,
    ry: 43.7598,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M386.881 196.263V104.102",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 440.806,
    cy: 106.754,
    rx: 46.8272,
    ry: 43.7598,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M440.805 214.828V122.667",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 851.553,
    cy: 129.668,
    rx: 24.3696,
    ry: 38.2378,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M851.555 200.018V154",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M649.199 175.506L649.199 185.136",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M724.766 164.272V185.136",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M635.461 164.272V185.136",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M173.463 164.272V185.136",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M145.986 84.0925L219.132 4.17236L293.953 84.0925",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M160.922 87.8974L184.678 62.5259V169.086",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M226.076 1H407.302L462.28 68.2344",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M447.352 94.8745V162.743",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 193.496,
    y: 67.6001,
    width: 24.4349,
    height: 24.1029,
    fill: "#CADDFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 193.496,
    y: 98.0464,
    width: 47.5123,
    height: 24.1029,
    fill: "#CADDFD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 193.496,
    y: 132.297,
    width: 24.4349,
    height: 36.7886,
    fill: "#F3C477"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M282.416 92.9717V167.818",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M178.566 33.9829V2.26855H192.82V20.6629",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteForUsBanner);
export default __webpack_public_path__ + "static/media/write-for-us-banner.44615799.svg";
export { ForwardRef as ReactComponent };